import { GoTOObligationHeader } from "./GoTOObligationHeader";
import { DynamicTabb } from "../../../../components/DynamicTab/DynamicTab";

export const G0ToObligation = () => {
  return (
    <div className="particcipentPage">
      <DynamicTabb />
      <GoTOObligationHeader />
    </div>
  );
};
